import {
  afterNextRender,
  afterRender, AfterRenderPhase, AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {WP_REST_API_Attachment} from "wp-types";
import {HasExtPipe} from "../../../pipes/has-ext.pipe";
import {AttachmentExtended} from "../../../models/Attachment/AttachmentExtended";
import {ReplacePipe} from "../../../pipes/replace.pipe";
import {StripTagsPipe} from "../../../pipes/striptags.pipe";
@Component({
  selector: 'media-attachment',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, HasExtPipe, ReplacePipe, StripTagsPipe],
  templateUrl: './media-attachment.component.html',
  styleUrl: './media-attachment.component.scss',
  host: {ngSkipHydration: 'true'}
})
export class MediaAttachmentComponent implements OnInit,AfterViewInit{
  @Input() attachment: AttachmentExtended | WP_REST_API_Attachment | null;
  @Input() url?: string;
  @Input() alt?: string;
  @Input() priority?: boolean = undefined;
  @Input() copyright?: string;
  @Input() displayCopyright?: boolean;
  @Input() loop?: boolean;
  @Input() forceCopyright?: boolean;
  @Input() sizeXS: number = 100;
  @Input() sizeSM: number = 100;
  @Input() sizeMD: number = 100;
  @Input() sizeLG: number = 100;
  @Input() sizeXL: number = 100;
  @Input() sizeXXL: number = 100;
  @Input() width?: number = undefined;
  @Input() height?: number = undefined;
  @Input() fill: boolean = true;
  @Input() optimized: boolean = true;
  @Input() loading?: "auto"|"lazy"|"eager" = "lazy";
  @Input() fit: "cover"|"inside"|"outside"|"fill"|"contain" = "cover";
  public sizes: string = ""
  @ViewChild("mediaAttachment") mediaAttachmentRef: ElementRef;
  @ViewChild("videoAttachment") videoAttachmentRef: ElementRef;
  @ViewChild("mediaUrl") mediaUrlRef: ElementRef;
  @ViewChild("videoUrl") videoUrlRef: ElementRef;
  public domLoaded = false;
  public mediaLoaded = false;
  public orientation: 'landscape'|'portrait' = 'landscape';
  @Input() forceBackground = false;
  constructor() {
    afterRender(()=>{
      this.addLoadListeners();
    })
  }


  ngAfterViewInit() {
    this.addLoadListeners();
  }

  addLoadListeners(){
    if(!this.domLoaded && this.mediaAttachmentRef){
      this.mediaAttachmentRef.nativeElement.onload = () => {
        this.mediaLoaded = true;
        this.defineOrientation();
      };
      this.domLoaded = true;
    }
    if(!this.domLoaded && this.mediaUrlRef){
      this.mediaUrlRef.nativeElement.onload = () => {
        this.mediaLoaded = true;
        this.defineOrientation();
      };
      this.domLoaded = true;
    }
  }

  ngOnInit() {
    this.sizes = `(max-width: 460px) ${this.sizeXS}vw,`;
    this.sizes+= ` (min-width: 461px) and (max-width: 645px) ${this.sizeSM}vw,`;
    this.sizes+= ` (min-width: 646px) and (max-width: 860px) ${this.sizeMD}vw,`;
    this.sizes+= ` (min-width: 861px) and (max-width: 1290px) ${this.sizeLG}vw,`;
    this.sizes+= ` (min-width: 1291px) and (max-width: 1920px) ${this.sizeXL}vw,`;
    this.sizes+= ` ${this.sizeXXL}vw`;
    if(this.priority){
      this.loading = undefined;
    }
  }

  defineOrientation(){
    if(this.mediaAttachmentRef){
      let el = this.mediaAttachmentRef.nativeElement;
      if(el && el.naturalHeight > el.naturalWidth){
        this.orientation = 'portrait';
      }
    }
    if(this.mediaUrlRef){
      let el = this.mediaUrlRef.nativeElement;
      if(el && el.naturalHeight > el.naturalWidth){
        this.orientation = 'portrait';
      }
    }
  }
}
